import { defineArrayMember, defineField, defineType } from "sanity";

export const returnsPage = defineType({
  name: "returnsPage",
  title: "Returns Page",
  type: "document",
  groups: [
    { name: "content", title: "Content", default: true },
    { name: "cta", title: "Bottom CTA" },
    { name: "seo", title: "SEO" }
  ],
  fields: [
    defineField({
      name: "title",
      title: "Page Title",
      type: "string",
      description: "The main heading displayed at the top of the page.",
      group: "content"
    }),
    defineField({
      name: "intro",
      title: "Intro Text",
      type: "text",
      rows: 3,
      description: "The introductory paragraph shown below the title.",
      group: "content"
    }),
    defineField({
      name: "sections",
      title: "Sections",
      type: "array",
      description: "The policy sections displayed as cards on the page. Drag to reorder.",
      of: [
        defineArrayMember({
          type: "object",
          fields: [
            defineField({
              name: "title",
              title: "Section Title",
              type: "string",
              validation: (Rule) => Rule.required()
            }),
            defineField({
              name: "body",
              title: "Section Body",
              type: "array",
              of: [{ type: "block" }]
            })
          ],
          preview: {
            select: { title: "title" },
            prepare: ({ title }) => ({ title: title || "Untitled section" })
          }
        })
      ],
      group: "content"
    }),
    defineField({
      name: "bottomCtaHeading",
      title: "Bottom CTA heading",
      type: "string",
      description: "Heading for the bottom call-to-action section (e.g. 'Need Help?').",
      group: "cta"
    }),
    defineField({
      name: "bottomCtaBody",
      title: "Bottom CTA body",
      type: "text",
      rows: 3,
      description: "Body text for the bottom call-to-action section.",
      group: "cta"
    }),
    defineField({
      name: "bottomCtaButtonText",
      title: "Bottom CTA button text",
      type: "string",
      description: "Text for the bottom CTA button (e.g. 'Contact us').",
      group: "cta"
    }),
    defineField({
      name: "bottomCtaButtonLink",
      title: "Bottom CTA button link",
      type: "string",
      description: "Link for the bottom CTA button (e.g. /contact).",
      group: "cta"
    }),
    defineField({
      name: "metaTitle",
      title: "Meta title",
      type: "string",
      description: "Page title for search engines (e.g. 'Returns & Exchanges | Vault 88').",
      group: "seo"
    }),
    defineField({
      name: "metaDescription",
      title: "Meta description",
      type: "text",
      rows: 3,
      description: "Short description for search engines.",
      group: "seo"
    }),
    defineField({
      name: "ogImage",
      title: "Sharing image",
      type: "image",
      description: "Image shown when this page is shared on social media.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "seo"
    })
  ],
  preview: {
    prepare: () => ({ title: "Returns Page" })
  }
});
